import React from "react";
import "../styles/details.sass";
import facebook from "../img/facebook.svg";
import location from "../img/location.svg";
import phone from "../img/phone.svg";
import envelope from "../img/envelope.svg";

const details = [
  {
    id: 1,
    icon: facebook,
    text: "https://www.facebook.com/BoroCarsMateuszBorolewski",
    description: "facebook.com/BoroCarsMateuszBorolewski",
    alt: "facebook",
  },
  {
    id: 2,
    icon: location,
    text: "https://maps.app.goo.gl/WXPnCxBKs4AwiPYX6",
    description: "Dragacz 41, 86-134",
    alt: "lokalizacja",
  },
  {
    id: 3,
    icon: phone,
    text: "tel:+48533340065",
    description: "+48 533 340 065",
    alt: "telefon",
  },
  {
    id: 4,
    icon: envelope,
    text: "mailto:mateusz.borolewski@interia.pl",
    description: "mateusz.borolewski@interia.pl",
    alt: "email",
  },
];
const generateDetails = details.map((detail) => {
  return (
    <div key={detail.id}>
      <a className={detail.alt} aria-label={detail.alt} href={detail.text}>
        <img src={detail.icon} alt={detail.alt} />
        <p>{detail.description}</p>
      </a>
    </div>
  );
});

const Details = () => {
  return <div className='details'>{generateDetails}</div>;
};

export default Details;
